module.exports = __webpack_public_path__ + "media/images/sort-direction-asc-f2285933a4422a39d15e964482c36478.svg";